import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../../data/testimonials';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-243" data-mp="3eah8yd43smgc">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className="h-4 w-4 fill-brand text-brand" aria-hidden="true" data-id="element-244" data-mp="3988ipoim7yhx" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section id="reviews" className="bg-sand py-20 md:py-28" data-id="element-245" data-mp="30ay7g35ss9d0">
      <div className="mx-auto max-w-7xl px-6" data-id="element-246" data-mp="2vieqcw7wiw3g">
        <div className="max-w-2xl" data-id="element-247" data-mp="2vgli5chn43tc">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brand" data-id="element-248" data-mp="2qj25ui4i6141">
            What our clients are saying
          </p>
          <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-249" data-mp="2lm1ym3vx2sbc">
            Why homeowners trust Restored Services
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-250" data-mp="2ckvgjqdmd9fz">
            From quick fixes to full-scale remodels, we show up on time, get the
            job done right, and leave your home better than we found it.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-251" data-mp="3vxtcmeepbstv">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-2xl border border-black/[0.07] bg-white p-7" data-id="element-252" data-mp="3m5xgh8w6ecsa">
              <Quote className="h-6 w-6 text-brand/30" aria-hidden="true" data-id="element-253" data-mp="dqwy56mqmihr" />
              <Stars data-id="element-254" data-mp="ipq9otigrzfa" />
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-255" data-mp="ioygtqg94fsp">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <footer className="mt-6 border-t border-black/[0.06] pt-4" data-id="element-256" data-mp="8qrcq8729s84">
                <p className="font-heading text-sm font-semibold text-ink" data-id="element-257" data-mp="8t54a72j8max">
                  {t.name}
                </p>
                <p className="mt-0.5 text-sm text-ink-soft/80" data-id="element-258" data-mp="2ti1afdkpv8iu">
                  {t.project} · {t.location}
                </p>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}